import { render, staticRenderFns } from "./form-generate-avg.vue?vue&type=template&id=34d7bbbe"
import script from "./form-generate-avg.vue?vue&type=script&lang=js"
export * from "./form-generate-avg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports